import { CONTAINER_HEIGHT_IN_MMM, TCG_IN_MMM } from "../consts";
import { pad2 } from "@tedivo/tedivo-pure-helpers";
/**
 * Calculates the physical (mm) layout of a bay's aft/cross-section diagram: row
 * positions by TCG and tier stacks by bottom base + container height. Contains no
 * SVG/DOM/pixel concerns - see `drawAftBayDiagram` (tedivo-bay-grid-core) for drawing.
 */
export function calculateAftBayLayout({ rows, tiersByRow, perRow, getTierHeightMm = () => CONTAINER_HEIGHT_IN_MMM, }) {
    var _a, _b;
    if (rows.length === 0)
        return undefined;
    const portRow = rows[0];
    const stbdRow = rows[rows.length - 1];
    const portTcg = (_a = perRow[portRow]) === null || _a === void 0 ? void 0 : _a.tcg;
    const stbdTcg = (_b = perRow[stbdRow]) === null || _b === void 0 ? void 0 : _b.tcg;
    if (portTcg === undefined || stbdTcg === undefined)
        return undefined;
    const widthMm = stbdTcg - portTcg + TCG_IN_MMM;
    if (isNaN(widthMm))
        return undefined;
    const addXMm = TCG_IN_MMM * 0.5 + Math.abs(portTcg);
    let minBB = Infinity;
    let maxBB = -Infinity;
    const rowsOut = [];
    rows.forEach((row, idx) => {
        var _a, _b, _c, _d, _e;
        const tcg = (_a = perRow[row]) === null || _a === void 0 ? void 0 : _a.tcg;
        if (tcg === undefined)
            return;
        const prevTcg = (_b = perRow[rows[idx - 1]]) === null || _b === void 0 ? void 0 : _b.tcg;
        const nextTcg = (_c = perRow[rows[idx + 1]]) === null || _c === void 0 ? void 0 : _c.tcg;
        const prevTcgMid = idx === 0 ? tcg - TCG_IN_MMM * 0.5 : ((prevTcg !== null && prevTcg !== void 0 ? prevTcg : tcg) + tcg) * 0.5;
        const nextTcgMid = idx === rows.length - 1 ? tcg + TCG_IN_MMM * 0.5 : ((nextTcg !== null && nextTcg !== void 0 ? nextTcg : tcg) + tcg) * 0.5;
        const rowTiers = tiersByRow[row];
        if (!rowTiers)
            return;
        const bottomBaseMm = (_d = perRow[row]) === null || _d === void 0 ? void 0 : _d.bottomBase;
        if (bottomBaseMm === undefined)
            return;
        const maxHeightMm = (_e = perRow[row]) === null || _e === void 0 ? void 0 : _e.maxHeight;
        const bottomTier = pad2(rowTiers.minTier);
        const topTier = pad2(rowTiers.maxTier);
        const numTiers = (Number(topTier) - Number(bottomTier)) * 0.5 + 1;
        const tierBasesMm = new Array(numTiers);
        let cumulativeHeight = 0;
        for (let t = 0; t < numTiers; t += 1) {
            tierBasesMm[t] = bottomBaseMm + cumulativeHeight;
            cumulativeHeight += getTierHeightMm(row, t);
        }
        if (maxHeightMm !== undefined && bottomBaseMm + maxHeightMm > maxBB) {
            maxBB = bottomBaseMm + maxHeightMm;
        }
        if (bottomBaseMm + cumulativeHeight > maxBB) {
            maxBB = bottomBaseMm + cumulativeHeight;
        }
        if (bottomBaseMm < minBB)
            minBB = bottomBaseMm;
        rowsOut.push({
            row,
            isPort: Number(row) % 2 === 0,
            tcg,
            prevTcgMid,
            nextTcgMid,
            bottomBaseMm,
            maxHeightMm,
            bottomTier,
            numTiers,
            tierBasesMm,
        });
    });
    return {
        widthMm,
        minBB,
        maxBB,
        addXMm,
        rows: rowsOut,
    };
}
